@if (this.dateTimeForm) {
  <form aria-labelledby="title" [formGroup]="dateTimeForm" novalidate>
    <div class="row m-0">
      <div
        [class.col-5]="dateTimeType === DateTimeType.DateTime"
        [class.col-12]="dateTimeType === DateTimeType.Date"
      >
        <div class="row align-items-center px-0">
          <div class="col-12 ps-0 px-0">
            <input
              ngbDatepicker
              type="text"
              name="date"
              formControlName="date"
              data-cy="date-input"
              class="form-control"
              container="body"
              #datePicker="ngbDatepicker"
              autocomplete="off"
              [placeholder]="MOMENT_DATE_FORMAT"
              [minDate]="momentToNgbDate(min)"
              [maxDate]="momentToNgbDate(max)"
              [ngClass]="{
                'control-status-success': c('date').dirty && c('date').valid,
                'control-status-danger': c('date').dirty && c('date').invalid,
              }"
              [attr.aria-invalid]="
                c('date').invalid && c('date').touched ? true : null
              "
              (click)="datePicker.toggle()"
            />
          </div>
        </div>
      </div>
      @if (dateTimeType === DateTimeType.DateTime) {
        <div class="col-7 p-0">
          <div class="row align-items-center m-0">
            <div class="col-6 col-hours">
              <input
                type="number"
                name="timeHour"
                formControlName="timeHour"
                [placeholder]="'shared.dateTime.placeholders.hour' | translate"
                class="form-control"
                autocomplete="off"
                [ngClass]="{
                  'control-status-success':
                    c('timeHour').dirty && c('timeHour').valid,
                  'control-status-danger':
                    c('timeHour').dirty && c('timeHour').invalid,
                }"
                [attr.aria-invalid]="
                  c('timeHour').invalid && c('timeHour').touched ? true : null
                "
                data-cy="hour-input"
              />
            </div>
            <div class="col-6">
              <input
                type="number"
                name="timeMinutes"
                formControlName="timeMinutes"
                [placeholder]="
                  'shared.dateTime.placeholders.minutes' | translate
                "
                class="form-control"
                autocomplete="off"
                [ngClass]="{
                  'control-status-success':
                    c('timeMinutes').dirty && c('timeMinutes').valid,
                  'control-status-danger':
                    c('timeMinutes').dirty && c('timeMinutes').invalid,
                }"
                [attr.aria-invalid]="
                  c('timeMinutes').invalid && c('timeMinutes').touched
                    ? true
                    : null
                "
                data-cy="minute-input"
              />
            </div>
          </div>
        </div>
      }
    </div>
    <div class="row align-items-center">
      <div class="col-12 ps-3">
        @if (c('date').invalid && c('date').touched) {
          @if (c('date').errors?.required) {
            <span class="caption text-danger">
              {{ 'shared.dateTime.errors.dateRequired' | translate }}
            </span>
          }
        }
        @if (dateTimeType === DateTimeType.DateTime) {
          @if (c('date').valid) {
            @if (c('timeHour').invalid && c('timeHour').touched) {
              @if (c('timeHour').errors?.required) {
                <span class="caption text-danger">
                  {{ 'shared.dateTime.errors.hourRequired' | translate }}
                </span>
              }
              @if (
                !c('timeHour').errors?.required && c('timeHour').errors?.pattern
              ) {
                <span class="caption text-danger">
                  {{ 'shared.dateTime.errors.hourPattern' | translate }}
                </span>
              }
            }
          }
          @if (c('date').valid && c('timeHour').valid) {
            @if (c('timeMinutes').invalid && c('timeMinutes').touched) {
              @if (c('timeMinutes').errors?.required) {
                <span class="caption text-danger">
                  {{ 'shared.dateTime.errors.minutesRequired' | translate }}
                </span>
              }
              @if (
                !c('timeMinutes').errors?.required &&
                c('timeMinutes').errors?.pattern
              ) {
                <span class="caption text-danger">
                  {{ 'shared.dateTime.errors.minutesPattern' | translate }}
                </span>
              }
            }
          }
        }
      </div>
    </div>
  </form>
} @else {
  <div class="pt-1 loading"></div>
}
